import { useState, useEffect } from "react";
import axiosInstance from "../utils/axiosInstance";

export const useCategories = () => {
    const [categories, setCategories] = useState([]);

    useEffect(() => {
        const loadCategories = async () => {
            const res = await axiosInstance.get('/category/list-with-products');

            const flatten = (items, parentId = null, level = 0) =>
                items
                    .filter(item => item.parent_category_id === parentId)
                    .flatMap(item => [
                        { ...item, level },
                        ...flatten(items, item.category_id, level + 1)
                    ]);

            setCategories(flatten(res.data));
        };

        loadCategories();
    }, []);

    return categories;
};
